// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::deep .sheet.theme--dark .v-sheet[data-v-85b4230a]{background-color:var(--v-background-dark-base)!important;color:var(--v-text-dark-base)!important}", ""]);
// Exports
module.exports = exports;
